module.exports = __webpack_public_path__ + "img/gh-22010.asm.985f1fb4.jpg";